export default "__VITE_ASSET__s7motFCfQkny44w9LPnPqg__"